import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { CostCodeGroupPicker } from 'components';

interface ICostCodeGroupFormFieldProps {
  className?: string | object;
  form: any;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
  autofocus?: boolean;
}

function CostCodeGroupFormField(props: ICostCodeGroupFormFieldProps) {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'cost-code-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <CostCodeGroupPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name as string} validations={validations} className={classes} render={renderField} />;
}

export default CostCodeGroupFormField;
